import React from "react";

const AdminItemAnalysis = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Item Analysis</h1>
      <div className="bg-white rounded-lg shadow-md border border-gray-200 p-8">
        <div className="text-center">
          <h2 className="text-3xl font-semibold text-gray-700 mb-4">
            Hello World
          </h2>
          <p className="text-gray-600 text-lg">
            This is the Item Analysis page. Content coming soon!
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminItemAnalysis;

